import { Fab, Grid } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import style from "components/url-desinger/social-network/social-network.module.scss";
import { useState } from "react";
import { useSelector } from "react-redux";
import { GetUrlBuilderData } from "store/url-builder";
import { AddSocialDialog } from "./add-social-dialog";
import { SocialNetworkList } from "./socials-list";

export enum SocialProvider {
  FACEBOOK = "Facebook",
  INSTAGRAM = "Instagram",
  PINTEREST = "Pinterest",
  TWITTER = "Twitter",
  LINKEDIN = "Linkedin",
  YOUTUBE = "Youtube",
  SNAPCHAT = "Snapchat",
  REDDIT = "Reddit",
  LINE = "Line",
  TWITCH = "Twitch",
  TELEGRAM = "Telegram",
  VIBER = "Viber",
  TIKTOK = "Tiktok",
  WHATSAPP = "WhatsApp",
  VIMEO = "Vimeo",
  THREADS = "Threads",
  EVENTBRITE = "Eventbrite",
  YELP = "Yelp",
  CALENDLY = "Calendly",
  REALTOR = "Realtor.com",
  ZILLOW = "Zillow.com",
}

export enum NewSocialProvider {
  LINKEDIN = "LinkedIn",
}

export interface SocialNetworksProps {
  builderType: string;
}

export const SocialNetworks = ({ builderType }: SocialNetworksProps) => {
  const builderData = useSelector(GetUrlBuilderData);
  const [openDialog, setOpenDialog] = useState(false);
  const handleDialogClose = () => setOpenDialog(false);

  return (
    <Grid container spacing={1} style={{ marginLeft: "10px" }}>
      <SocialNetworkList
        socialNetworks={builderData.socialNetworks}
        onItemClick={() => setOpenDialog(true)}
      />
      <Grid item>
        <Fab
          onClick={() => setOpenDialog(true)}
          classes={{ root: style.networksButton }}
          color="primary"
          aria-label="add"
        >
          <AddIcon />
        </Fab>
      </Grid>
      {openDialog && (
        <AddSocialDialog
          isOpen={openDialog}
          onClose={handleDialogClose}
          builderType={builderType}
        />
      )}
    </Grid>
  );
};
